/**
 * Angular 2 decorators and services
 */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';
import { AppState } from './app.service';
import { ResponsiveService } from './responsive/responsive.service';
import { UIRouter, Transition } from '@uirouter/core';
import { CheckoutService } from './checkout/checkout.service';

/**
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './app.component.scss'
  ],
  template: `
    <div class="app-wrapper">
      <ui-view></ui-view>
    </div>
  `
})
export class AppComponent implements OnInit {
  constructor(
    public appState: AppState,
    private router: UIRouter,
    private responsiveService: ResponsiveService,
    private checkoutService: CheckoutService
  ) {}

  public ngOnInit() {
    this.responsiveService.init();
    this.checkoutService.init();

    const currentState = this.router.stateService.transition.to();

    this.appState.change.subscribe(
      (state) => {
        if (state.property === 'appLoaded') {
          if (state.newValue === true) {
            document.getElementById('full_page_loader').classList.add('full-page-loader-inactive');
          }
        } else if (state.property === 'loading') {
          if (state.newValue) {
            document.getElementById('full_page_loader').classList.remove('full-page-loader-inactive');
          } else {
            document.getElementById('full_page_loader').classList.add('full-page-loader-inactive');
          }
        }
      }
    );

    if (currentState.params) {
      if (currentState.params.backgroundLight) {
        document.getElementsByTagName('body')[0].classList.add('light');
      }
    }

    this.router.transitionService.onStart(
      {},
      (transition: Transition) => {
        const to = transition.to();

        if (to.params) {
          if (to.params.loader && to.params.loader.start) {
            this.appState.set('loading', true);
          }

          if (to.params.backgroundLight) {
            document.getElementsByTagName('body')[0].classList.add('light');
          } else {
            document.getElementsByTagName('body')[0].classList.remove('light');
          }
        } else {
          document.getElementsByTagName('body')[0].classList.remove('light');
        }

        this.appState.set('isMenuActive', false);
      }
    );

    this.router.transitionService.onSuccess(
      {},
      (transition: Transition) => {
        const to = transition.to();
        const params = transition.params();

        if (to.params && to.params.loader) {
          if (to.params.loader.end) {
            this.appState.set('loading', false);
          }
        }

        if (!params['#']) {
          window.scrollTo(0, 0);
        } else {
          const element = window.document.getElementById(params['#']);

          if (element) {
            setTimeout(() => {
              element.scrollIntoView({ block: 'start' });
            }, 100);
          } else {
            window.scrollTo(0, 0);
          }
        }
      }
    );

    this.appState.set('appLoaded', true);
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts